import React,{Component} from 'react'
import Hero from './Hero'
import MosaicGrid from './MosaicGrid'
import Features from './Features'
import TrailingCta from './TrailingCta'
import Footer from './Footer'

class App extends Component
	render: ()->
		<div>
			<Hero />
			<Features />
			<TrailingCta />
			<Footer />
		</div>
	
	componentDidMount: ()->
		saveMarketingAttrsFromHref()


export saveMarketingAttrs = (attrs)->
	try sessionStorage.setItem('marketing-attrs', JSON.stringify(attrs))

export getMarketingAttrs = (attrs)->
	try
		o = sessionStorage.getItem('marketing-attrs')
		o = if o then JSON.parse(o) else {}
		o.source ?= 'landing'
		return o

export saveMarketingAttrsFromHref = ()->
	attrs = getMarketingAttrsFromHref()
	if Object.keys(attrs).length
		saveMarketingAttrs(attrs)

export getMarketingAttrsFromHref = ()->
	o = {}
	query = window.location.search.slice(1)
	entries = query.split('&').map (entry)->
		[name,value] = entry.split('=')
		return {name, value}
		# return {"#{name}":value}
	
	refEntry = entries.find name:'ref'
	o.ref = refEntry.value if refEntry
	
	fbadvEntry = entries.find name:'fbadv' # facebook ad version
	if fbadvEntry
		o.source = 'facebook'
		o.meta ?= {}
		o.meta.fbadv = fbadvEntry.value
		
	fbadsEntry = entries.find name:'fbads' # facebook ad size/variant
	if fbadsEntry
		o.meta ?= {}
		o.meta.fbads = fbadsEntry.value
	
	return o


export default App